module.exports = __webpack_public_path__ + "static/img/main.dfc1a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/18/main.png
// module id = sJwJ
// module chunks = 1